package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_05_02_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The thick tree cover blocks out nearly all sunlight. It is quiet with only an occasional crow’s caw. The ground is littered with pools of stinking, stagnant water.  Elrovir loses the path of the booted travelers (likely the dark elf adventurers), but Caper and Falorn spot some branches broken by a blade (half a day old cut). Around afternoon, the heroes feel an instinctual dread — the hair on the back of their necks stands up — are they being watched? Tuesday asks a tree for directions in Sylvan; the tree does not respond. Caper picks up the trail of the booted travelers again (8-10 hours old).")
    }
}
